// Define FilterOption type with type as "checkbox" or "range"
import React from 'react';
type FilterOption = {
  label: string;
  key: string;
  type: 'checkbox' | 'range'; // or any other types you need
  options: string[]; // List of filter options
};

export const getFilterLabels = (): FilterOption[] => {
  return [
    {
      label: 'Related Field',
      key: 'relatedField',
      type: 'checkbox', // Specify the type explicitly
      options: ['Software / IT', 'Networking', 'Web UI', 'HR', 'Nursing'],
    },
    {
      label: 'Level',
      key: 'level',
      type: 'checkbox', // Specify the type explicitly
      options: ['Intern', 'Associate', 'Junior', 'Mid-Level', 'Senior'],
    },
    {
      label: 'Job Title',
      key: 'jobTitle',
      type: 'checkbox', // Specify the type explicitly
      options: [
        'Associate Frontend Engineer',
        'Junior Frontend Developer',
        'Frontend Developer',
        'Senior Frontend Engineer',
        'Network Engineer',
        'Network Administrator',
        'Cybersecurity Analyst',
        'UI/UX Designer',
        'UX Researcher',
        'Visual Designer',
        'Accessibility Specialist',
        'HR Manager',
        'HR Coordinator',
        'HR Consultant',
        'Registered Nurse',
        'Nursing Intern',
        'Staff Nurse',
        'Nurse Practitioner',
      ],
    },
  ];
};
